<!--Desktop Back Button-->
<div class="container pt-3 d-none d-lg-block">
  <button class="back-btn d-flex align-items-center justify-content-center" (click)="goBack()" aria-label="Back">
    <span class="material-icons text-white">arrow_back_ios</span>
  </button>
</div>

<!--Mobile Navigation-->
<fgb-mobile-nav-menu
  [pageName]="'wallet.redemption.title' | translate"
  [showHamburger]="false"
  [showWalletButton]="false"
></fgb-mobile-nav-menu>

<div class="bg-primary d-lg-none mobile-header-background"></div>
<div class="container mobile-page-content">
  <div class="page-padding"><fgbcl-lottos-wallet-details [lottoId]="id"></fgbcl-lottos-wallet-details></div>
</div>
